import { getBrowserThemeMode } from '#web-oura-tools/theme/utilities'

import { applyTailwindTheme, getTailwindThemes } from '#web-oura-tools/theme/frameworks/tailwind'
import { getVuetifyThemes } from '#web-oura-tools/theme/frameworks/vuetify'

export default function useOuraTheme() {
  return {
    getVuetifyThemes,
    getTailwindThemes,
    applyTailwindTheme,
    getBrowserThemeMode,
  }
}
